<template>
  <div v-loading="fullscreenLoading">
    <div style="margin-left: 10.5%">
      <div style="padding-top: 20px"></div>
      <div
        class="Rectangle-5"
        v-bind:style="{ height: +(windowHeight - 200) + 'px' }"
      >
        <div style="padding: 3%">
          <div style>
            <div style="display: inline-block; width: 70%">
              <el-button
                @click="onDialogBoolAddNewOpen()"
                style="color: #1bb24b; border-color: #1bb24b"
                >添加新Banner</el-button
              >
            </div>
            <div style="display: inline-block; text-align: right; width: 30%">
              <div
                style="
                  display: inline-block;
                  text-align: right;
                  max-width: 40%;
                  margin-right: 10px;
                "
              ></div>
            </div>
          </div>

          <div style="margin-top: 3%">
            <el-table
              :data="tableDataList"
              :height="windowHeight - 450"
              style="width: 100%"
              stripe
            >
              <el-table-column
                prop="type"
                label="类型"
                width="300"
              ></el-table-column>
              <el-table-column
                prop="param"
                label="跳转至（商品ID、小程序APPID、分类ID）"
              ></el-table-column>
              <el-table-column label="图片(375px x 202px)">
                <template slot-scope="scope">
                  <img
                    style="width: 375px; height: 202px"
                    :src="scope.row.imgUrl"
                  />
                </template>
              </el-table-column>

              <el-table-column fixed="right" label="操作" width="250">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'edit')"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'delete')"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 20px"></div>
        </div>
      </div>

      <el-dialog
        title="图片操作"
        :visible.sync="boolAddNew"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolAddNewClose"
      >
        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            类型
          </div>
          <el-select
            @change="onChangeType"
            style="display: inline-block; width: 70%"
            v-model="form.type"
          >
            <el-option
              v-for="item in typeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div v-if="form.type == '小程序'" style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            小程序参数
          </div>
          <el-input
            style="display: inline-block; width: 70%"
            v-model="form.param"
            placeholder="请输入appId"
          ></el-input>
        </div>

        <div v-if="form.type == '商品'" style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            商品
          </div>
          <el-select
            filterable
            style="display: inline-block; width: 70%"
            v-model="form.param"
          >
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <div v-if="form.type == '分类'" style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            分类
          </div>
          <el-select
            style="display: inline-block; width: 70%"
            v-model="form.param"
          >
            <el-option
              v-for="item in cateList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px">
          <div
            style="
              display: inline-block;
              text-align: left;
              width: 10%;
              vertical-align: top;
            "
          >
            图片
          </div>

          <div style="display: inline-block; width: 70%">
            <el-upload
              accept=".jpg, .jpeg, .png"
              class="avatar-uploader"
              :show-file-list="false"
              action="https://freshgo.top/api/public/api/v1/uploadFileQiniu"
              :on-success="onImgUpload"
              :on-remove="onImgRemove"
            >
              <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            v-if="boolEdit"
            @click="onEditConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            v-if="boolEdit == false"
            @click="onAddNewConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolAddNewClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="删除图片"
        :visible.sync="boolDelete"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolDeleteClose"
      >
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onDeleteConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolDeleteClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "imgModify",
  data() {
    return {
      fullscreenLoading: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,

      searchKeyword: "",

      currentData: {},
      currentPage: 1,

      tableDataList: [],
      tableDataTotal: 0,
      boolAddNew: false,
      boolEdit: false,
      boolDelete: false,

      form: {
        type: "",
        param: "",
        imgUrl: "",
      },
      typeList: ["普通", "商品", "小程序", "分类"],
      productList: [],
      cateList: [],
    };
  },
  mounted() {},
  created() {
    this.onCheckloginRole();
    this.onFetchTableData();
    this.onFetchProductCategoriesData();
    this.onFetchProductData();
  },
  methods: {
    // check if  login
    onCheckloginRole() {
      // var temp = localStorage.getItem("auth");
      // if (temp == undefined || temp != "b60afdc1f3657130c165d32743603a59") {
      //   this.$router.push("/login");
      // }
      var temp = localStorage.getItem("auth");
      this.axios
        .post(this.$urlGlobal + "adminCheck", {
          auth: temp,
        })
        .then((res) => {
          if (res.data.code == -1) {
            this.$router.push("/login");
            localStorage.removeItem("auth");
            window.location.reload();
          }
        });
    },

    // fetch categories
    onFetchProductCategoriesData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchCategories", {})
        .then((res) => {
          this.cateList = res.data.data;
          this.fullscreenLoading = false;
        });
    },

    // search  table by name
    onSearchTableData() {
      // init the page and fetch data
      this.currentPage = 1;
      this.onFetchTableData();
    },
    // fetch table data also with condition
    onFetchTableData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchBanner", {
          keyword: this.searchKeyword,
          page: this.currentPage,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.tableDataList = res.data.data;
        });
    },

    // fetch all product
    onFetchProductData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchAllProduct", {})
        .then((res) => {
          this.fullscreenLoading = false;
          this.productList = res.data.data;
        });
    },

    // add new  operation
    onDialogBoolAddNewOpen() {
      this.boolAddNew = true;
    },
    onDialogBoolAddNewClose() {
      this.boolAddNew = false;
      // also close edit because they use same form
      this.boolEdit = false;
      this.form = {
        type: "",
        param: "",
        imgUrl: "",
      };
    },
    onAddNewConfirm() {
      if (this.form.type == "" || this.form.imgUrl == "") {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.fullscreenLoading = true;
      this.boolAddNew = false;

      this.axios
        .post(this.$urlGlobal + "adminAddNewBanner", {
          type: this.form.type,
          imgUrl: this.form.imgUrl,
          param: this.form.param,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "新增失败",
              type: "warning",
            });
          } else {
            this.$message({
              message: "增加成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewClose();
          this.onFetchTableData();
        });
    },

    // edit  operation
    onDialogBoolEditOpen() {
      this.boolAddNew = true;
      this.boolEdit = true;
      this.form = {
        type: this.currentData.type,
        param: this.currentData.param,
        imgUrl: this.currentData.imgUrl,
      };
    },
    onEditConfirm() {
      if (this.form.type == "" || this.form.imgUrl == "") {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminEditBanner", {
          id: this.currentData.id,
          type: this.form.type,
          param: this.form.param,
          imgUrl: this.form.imgUrl,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "修改失败",
              type: "warning",
            });
            return;
          } else {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewClose();
          this.onFetchTableData();
        });
    },

    // image operation
    onImgRemove(file, fileList) {
      this.form.imgUrl = "";
    },
    onImgUpload(file) {
      this.form.imgUrl = file.data;
    },

    // delete  operation
    onDialogBoolDeleteOpen() {
      this.boolDelete = true;
    },
    onDialogBoolDeleteClose() {
      this.boolDelete = false;
    },
    onDeleteConfirm() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminDeleteBanner", {
          id: this.currentData.id,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.onDialogBoolDeleteClose();
          this.onFetchTableData();
        });
    },

    // change type operation
    onChangeType(val) {
      console.log(val);
      this.form.param = "";
    },

    // table operation
    onDialogWithData(scope, e) {
      this.currentData = scope.row;
      switch (e) {
        case "edit":
          this.onDialogBoolEditOpen();
          break;
        case "delete":
          this.onDialogBoolDeleteOpen();
          break;
      }
    },
  },
};
</script>

